var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBetaOffer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 46,
    viewBox: "0 0 49 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4531 33.5156L26.2734 32.7812L24.0703 46L35.4531 33.5156Z",
    fill: "#E9B50F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8906 32.0469L13.7891 27.6406H41.3281L28.1094 29.8437L14.8906 32.0469Z",
    fill: "#E9B50F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4531 33.5156L33.9844 28.7422L14.8906 32.0469L35.4531 33.5156Z",
    fill: "#FFD54F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49 0L0 2.51282L4.58273 28H41.5971L49 0Z",
    fill: "#FFD54F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6615 11.124V9.756H10.4575V18H11.9575V14.58H16.2175V13.212H11.9575V11.124H16.6615ZM24.7132 18L22.6492 15.072C23.8372 14.7 24.6412 13.74 24.6412 12.492C24.6412 10.884 23.3212 9.756 21.5572 9.756H17.9692V18H19.4692V15.228H21.0652L23.0092 18H24.7132ZM19.4692 11.136H21.3892C22.4092 11.136 23.1172 11.652 23.1172 12.492C23.1172 13.332 22.4092 13.848 21.3892 13.848H19.4692V11.136ZM32.2005 11.124V9.756H25.9965V18H32.2005V16.632H27.4965V14.484H31.7565V13.116H27.4965V11.124H32.2005ZM39.8412 11.124V9.756H33.6372V18H39.8412V16.632H35.1372V14.484H39.3972V13.116H35.1372V11.124H39.8412Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaOffer);
export default __webpack_public_path__ + "static/media/beta_offer.bdc7b37e9b0ef892836266eb6796f067.svg";
export { ForwardRef as ReactComponent };